function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "fill stroke",
  d: "M3.915-47A10.927,10.927,0,0,0-7-36.084,10.928,10.928,0,0,0,3.915-25.169,10.928,10.928,0,0,0,14.83-36.084,10.928,10.928,0,0,0,3.915-47ZM-5.509-36.084a9.388,9.388,0,0,1,2.473-6.357,9.312,9.312,0,0,1,2.47,6.357,9.31,9.31,0,0,1-2.47,6.357A9.388,9.388,0,0,1-5.509-36.084Zm3.563,7.374A10.952,10.952,0,0,0,.926-36.084a10.953,10.953,0,0,0-2.872-7.374,9.377,9.377,0,0,1,5.861-2.05,9.378,9.378,0,0,1,5.861,2.05A10.952,10.952,0,0,0,6.9-36.084,10.952,10.952,0,0,0,9.776-28.71a9.379,9.379,0,0,1-5.861,2.05A9.377,9.377,0,0,1-1.946-28.71Zm12.812-1.017A9.312,9.312,0,0,1,8.4-36.084a9.311,9.311,0,0,1,2.47-6.357,9.388,9.388,0,0,1,2.474,6.357A9.386,9.386,0,0,1,10.866-29.727Z",
  transform: "matrix(0.978, 0.208, -0.208, 0.978, 1.97, 47.783)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.6
});

var SvgTennis = function SvgTennis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tennis",
    className: "fill-stroke",
    width: 26.604,
    height: 26.604,
    viewBox: "0 0 26.604 26.604",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTennis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tennis.4d24c961.svg";
export { ForwardRef as ReactComponent };